import { defineStore } from 'pinia';
import { setUserPrefs, removeUserPrefs } from '@/services/preferences';

export const useUserStore = defineStore('user', {
  state: () => ({
    // usar sessionStorage para que la sesión se cierre al cerrar el navegador
    name: sessionStorage.getItem('user_name') || '',
    role: Number(sessionStorage.getItem('user_role')) || null,
    token: sessionStorage.getItem('auth_token') || '',
  }),
  actions: {
    setUser({ name, role, token }) {
      this.name = name;
      this.role = role;
      this.token = token;
      sessionStorage.setItem('user_name', name);
      sessionStorage.setItem('user_role', role);
      sessionStorage.setItem('auth_token', token);
      // persistir nativamente (no await para no bloquear la UI)
      setUserPrefs({ auth_token: token, user_name: name, user_role: role }).catch(e => console.warn('setUserPrefs failed', e));
    },
    clearUser() {
      this.name = '';
      this.role = null;
      this.token = '';
      sessionStorage.removeItem('user_name');
      sessionStorage.removeItem('user_role');
      sessionStorage.removeItem('auth_token');
      // eliminar prefs nativas
      removeUserPrefs().catch(e => console.warn('removeUserPrefs failed', e));
    }
  }
});